import React from 'react';
import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';

interface ApprovalDateProps {
  approvedDate?: string | null;
  rejectedDate?: string | null;
}

/**
 * Displays approval or rejection date.
 */
export const ApprovalDate: React.FC<ApprovalDateProps> = ({ approvedDate, rejectedDate }) => {
  const date = approvedDate || rejectedDate;
  if (!date) return <span>-</span>;
  return <span>{new Date(date).toLocaleDateString()}</span>;
};

/** Syncfusion grid template wrapper */
export const approvalDateTemplate = (props: WriteoffApprovalView) => (
  <ApprovalDate approvedDate={props.approvedDate} rejectedDate={props.rejectedDate} />
);

export default ApprovalDate;
